<template>
    <div>
        <rkm-table
            v-if="!readonly"
            :fields="fields"
            :items="data.model.problemasCondicoes"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(ciap)="{item}">
                {{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
            </template>

            <template v-slot:cell(cid)="{item}">
                {{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    :disabled="(data.additionals.hasGravidezAltoRisco && isGravidezNormal(item)) || item.automatico"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="(data.additionals.hasGravidezAltoRisco && isGravidezNormal(item)) || item.automatico"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-area
            v-else
            background-color="primary"
            no-margin-top
            title="Histórico de problemas e/ou condições ativos e latentes"
            type="box"
        >
            <rkm-list
                :items="data.form.problemaCondicao.problemasCondicoesPaciente"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <rkm-row>
                        <rkm-col cols="5">
                            <strong>CIAP 2</strong><br />{{item.ciap.id ? `${item.ciap.codigo} - ${item.ciap.descricao}` : '-'}}
                        </rkm-col>

                        <rkm-col cols="5">
                            <strong>CID 10</strong><br />{{item.cid.id ? `${item.cid.codigo} - ${item.cid.nome}` : '-'}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Situação</strong><br />{{item.inicio}}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="5">
                            <strong>Início</strong><br />{{item.inicio}}
                        </rkm-col>

                        <rkm-col cols="5">
                            <strong>Fim</strong><br />{{item.fim}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:collapse="{item}">
                    <rkm-row class="p-2">
                        <rkm-col>
                            {{item.observacao ? item.observacao : '-'}}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {ambulatorioAtendimentoPreNatal} from '@/mixins'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {key: 'cid', label: 'CID 10', sortable: true},
            {key: 'situacaoNome', label: 'Situação', sortable: true},
            {key: 'inicio.data', label: 'Início', sortable: true},
            {key: 'fim.data', label: 'Fim', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'}
        ],
    }),
    methods: {
        destroy(item) {
            const isProblemaCondicaoGravidezNormalAutomatico = this.data.additionals.problemaCondicaoGravidezNormal && this.data.additionals.problemaCondicaoGravidezNormal.automatico
            const isUltimoProblemasCondicoesGravidezAltoRisco = this.data.additionals.problemasCondicoesGravidezAltoRisco.length === 1 && this.isGravidezAltoRisco(item)

            if (this.isGravidezNormal(item)) {
                this.showDeleteConfirmation('Deseja realmente excluir o problema/condição? Os campos de pré-natal serão desabilitados, os dados contidos nos mesmos serão perdidos.', async () => {
                    this.data.model.problemasCondicoes.splice(this.data.model.problemasCondicoes.indexOf(item), 1)
                    this.resetFormPreNatal()
                })
            }
            else if (isUltimoProblemasCondicoesGravidezAltoRisco && isProblemaCondicaoGravidezNormalAutomatico) {
                this.showDeleteConfirmation('Deseja realmente excluir o problema/condição? Os campos de pré-natal serão desabilitados, os dados contidos nos mesmos serão perdidos.', async () => {
                    const problemaCondicaoGravidezNormal = this.data.additionals.problemaCondicaoGravidezNormal

                    if (problemaCondicaoGravidezNormal && problemaCondicaoGravidezNormal.automatico) {
                        this.data.model.problemasCondicoes.splice(this.data.model.problemasCondicoes.indexOf(problemaCondicaoGravidezNormal), 1)
                    }

                    this.data.model.problemasCondicoes.splice(this.data.model.problemasCondicoes.indexOf(item), 1)

                    this.resetFormPreNatal()
                })
            } else {
                this.showDeleteConfirmation('Deseja realmente excluir o problema/condição?', async () => {
                    this.data.model.problemasCondicoes.splice(this.data.model.problemasCondicoes.indexOf(item), 1)
                })
            }
        },
        resetFormPreNatal() {
            this.data.model.preNatal.gravidezTipoId = null
            this.data.model.preNatal.alturaUterina = null
            this.data.model.preNatal.gravidezAltoRisco = null
            this.data.model.preNatal.edemaId = null
            this.data.model.preNatal.movimentacaoFetal = null
            this.data.model.preNatal.gravidezPlanejada = null
            this.data.model.preNatal.batimentoCardiacoFetal = null
            this.data.model.preNatal.desfechoEm = null
            this.data.objetivoModel.preNatal.alturaUterina = null
            this.data.objetivoModel.preNatal.gravidezAltoRisco = null
            this.data.objetivoModel.preNatal.edemaId = null
            this.data.objetivoModel.preNatal.movimentacaoFetal = null
            this.data.objetivoModel.preNatal.gravidezPlanejada = null
            this.data.objetivoModel.preNatal.batimentoCardiacoFetal = null
            this.data.objetivoModel.preNatal.desfechoEm = null
            this.data.objetivoModel.dum = null
        },
    },
    mixins: [ambulatorioAtendimentoPreNatal],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, required: true},
    },
}
</script>